import { render, staticRenderFns } from "./platformWallet.vue?vue&type=template&id=3dbff7ad&"
import script from "./platformWallet.vue?vue&type=script&lang=js&"
export * from "./platformWallet.vue?vue&type=script&lang=js&"
import style0 from "./platformWallet.vue?vue&type=style&index=0&id=3dbff7ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports